import { template } from "@ember/template-compiler";
import i18n from "discourse-common/helpers/i18n";
const FilterForMore = template(`
  {{#if @collection.content.shouldShowMoreTip}}
    <div class="filter-for-more">
      {{i18n "select_kit.components.filter_for_more"}}
    </div>
  {{/if}}
`, {
  eval() {
    return eval(arguments[0]);
  }
});
export default FilterForMore;